import React from 'react'
import PropTypes from 'prop-types'
import { ModalContext } from 'src/contexts'
import { useHandler } from 'src/hooks'
import { TimesIcon, SaveIcon } from 'src/components'
import ModalBlock from '../ModalBlock'
import { ButtonIcon } from '../../buttons'
import { LocalizedText } from '../../intl'
import ModalToolbar from '../ModalToolbar'

const ConfirmModal = ({ canConfirm, onCancel, onConfirm, ...props }) => {
  const { close } = ModalContext.use()
  return (
    <ModalBlock
      toolbar={
        <ModalToolbar>
          <ButtonIcon icon={TimesIcon} onClick={useHandler((...args) => close() || (onCancel && onCancel(...args)))}>
            <LocalizedText id="WEB_CANCEL" />
          </ButtonIcon>
          <ButtonIcon
            icon={SaveIcon}
            disabled={!canConfirm}
            onClick={useHandler((...args) => close() || (onConfirm && onConfirm(...args)))}
          >
            <LocalizedText id="WEB_VALID" />
          </ButtonIcon>
        </ModalToolbar>
      }
      {...props}
    />
  )
}

ConfirmModal.defaultProps = {
  canConfirm: true,
}

ConfirmModal.propTypes = {
  title: PropTypes.node,
  canConfirm: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  children: PropTypes.node,
}

export default ConfirmModal
